/*=========================================================================================
  File Name: actions.js
  Description: Vuex Store - actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuesax Admin - VueJS Dashboard Admin Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import axios from '../plugins/http-axios.js';
// import _axios from 'axios';
import Axios from 'axios';

let debugConsole = false;
let apiDomain, newApiDomain, fiatApiDomain;
if (process.env.VUE_APP_LOCAL_ENV) {
  apiDomain = process.env.VUE_APP_API_DOMAIN_LOCAL;
  newApiDomain = process.env.VUE_APP_API_DOMAIN_NEW_DASHBOARD_API_LOCAL;
  fiatApiDomain = process.env.VUE_APP_FIAT_PAYOUT_API_DOMAIN_LOCAL;
} else if (process.env.VUE_APP_STAGING_ENV) {
  apiDomain = process.env.VUE_APP_API_DOMAIN_TESTING;
  newApiDomain = process.env.VUE_APP_API_DOMAIN_NEW_DASHBOARD_API_TESTING;
  fiatApiDomain = process.env.VUE_APP_FIAT_PAYOUT_API_DOMAIN_TESTING;
} else if (process.env.VUE_APP_UAT_ENV) {
  apiDomain = process.env.VUE_APP_API_DOMAIN_UAT;
  newApiDomain = process.env.VUE_APP_API_DOMAIN_NEW_DASHBOARD_API_UAT;
  fiatApiDomain = process.env.VUE_APP_FIAT_PAYOUT_API_DOMAIN_UAT;
} else {
  apiDomain = process.env.VUE_APP_API_DOMAIN;
  newApiDomain = process.env.VUE_APP_API_DOMAIN_NEW_DASHBOARD_API;
  fiatApiDomain = process.env.VUE_APP_FIAT_PAYOUT_API_DOMAIN;
}

const actions = {
  // ////////////////////////////////////////////
  // TripleA actions
  // ////////////////////////////////////////////

  //Action-based action (using old or account-based api)
  // async fetchAddressesAction({commit, getters, state}) {
  //   console.warn('fetchAddressesAction : starting.....')
  //   let identifier;
  //   let account = getters.activeAccountGetter;
  //
  //
  //   if (!account) {
  //     console.warn(
  //       "fetchAddressesAction: No active account! Cannot fetch addresses"
  //     );
  //     return;
  //   }
  //
  //   if (state.activeUser === null) {
  //     identifier = account.pubkey;
  //   } else {
  //     identifier = account.apiId;
  //   }
  //
  //
  //   let url = `${apiDomain}/v1/dashboard/account/${identifier}/addresses`;
  //   const headers = {
  //     headers: {
  //       "Content-Type": "application/application-json",
  //       Authorization: `Bearer ${state.activeUser.userToken}`
  //     }
  //   };
  //   try {
  //     let result = await axios.get(url, headers)
  //
  //     if (debugConsole) console.debug("Address Result", result.data);
  //
  //     let addressesList = result.data.data || [];
  //     let meta = result.data.meta || {};
  //     // console.log("Result meta without filter", result.data);
  //
  //     commit('UPDATE_ACCOUNT_ADDRESSES', {
  //       apiId: identifier,
  //       metaAddress: meta,
  //       addresses: addressesList
  //     })
  //     return result;
  //   } catch (err) {
  //     console.log('Addresses error', err)
  //   }
  //
  // },
  //
  // async fetchAddressActionWithFilter({commit, getters, state}, payload) {
  //   console.warn('fetchAddressesAction : starting.....')
  //   let identifier;
  //   let account = getters.activeAccountGetter;
  //
  //
  //   if (!account) {
  //     console.warn(
  //       "fetchAddressesAction: No active account! Cannot fetch addresses"
  //     );
  //     return;
  //   }
  //
  //   if (state.activeUser === null) {
  //     identifier = account.pubkey;
  //   } else {
  //     identifier = account.apiId;
  //   }
  //
  //   let query_string = [];
  //   if (payload.search_text) {
  //     if (debugConsole) console.log("Search Text", payload.search_text);
  //     query_string.push(`q=${payload.search_text}`);
  //   }
  //
  //   if (payload.from_date) {
  //     if (debugConsole) console.log("From Date", payload.from_date);
  //     query_string.push(`from_date=${payload.from_date}`);
  //
  //   }
  //
  //   if (payload.to_date) {
  //     if (debugConsole) console.log("To Date", payload.to_date);
  //     query_string.push(`to_date=${payload.to_date}`);
  //   }
  //
  //   if (debugConsole) console.log("Query String", query_string);
  //
  //   let url = `${apiDomain}/v1/dashboard/account/${identifier}/addresses?${query_string.join('&')}`;
  //   const headers = {
  //     headers: {
  //       "Content-Type": "application/application-json",
  //       Authorization: `Bearer ${state.activeUser.userToken}`
  //     }
  //   };
  //
  //   try {
  //     let result = await axios.get(url, headers)
  //
  //     if (debugConsole) console.debug("Address Result with search & filter", result.data);
  //
  //     let addressesList = result.data.data || [];
  //     let meta = result.data.meta || {};
  //
  //     // console.log("Result meta with filter",result.data);
  //
  //     commit('UPDATE_ACCOUNT_ADDRESSES', {
  //       apiId: identifier,
  //       metaAddress: meta,
  //       addresses: addressesList
  //     })
  //     return result;
  //
  //   } catch (err) {
  //     console.error('Addresses Result with search & filter error', err)
  //     return err;
  //   }
  //
  //
  // },
  //
  // async fetchAddressesCountAction({commit, getters, state}, {daysToDisplay}) {
  //   console.warn("fetchAddressesCountsAction: starting...");
  //
  //   let account = getters.activeAccountGetter;
  //
  //   if (!account) {
  //     console.warn(
  //       "fetchAddressesCountsAction: No active account! Cannot fetch address counts"
  //     );
  //     return;
  //   }
  //
  //   let identifier = account.apiId;
  //
  //   let toDate = new Date().setUTCHours(23, 59, 59, 999);
  //   // console.log("To Date", new Date(toDate).toISOString())
  //   let fromDate =
  //     new Date().setUTCHours(0, 0, 0, 0) - 24 * 60 * 60 * 1000 * daysToDisplay;
  //   // console.log("From Date", new Date(fromDate).toISOString())
  //
  //   toDate = new Date(toDate).toISOString().split("T")[0];
  //   fromDate = new Date(fromDate).toISOString().split("T")[0];
  //
  //   let url = `${apiDomain}/v1/dashboard/account/${identifier}/addresses/count?from_date=${fromDate}&to_date=${toDate}`;
  //   const headers = {
  //     headers: {
  //       Authorization: `Bearer ${state.activeUser.userToken}`
  //     }
  //   };
  //
  //   try {
  //     let result = await axios.get(url, headers);
  //     console.log("Result address count", result.data);
  //     if (debugConsole) console.debug('Address count result', result.data.address_counts)
  //
  //     let countResult = result.data.address_counts;
  //
  //     commit('UPDATE_ACCOUNT_ADDRESSES_COUNT', {
  //       apiId: identifier,
  //       addressesCount: countResult
  //     })
  //     return result;
  //   } catch (err) {
  //     console.log('Address Count Error', err)
  //   }
  // },
  //
  // async fetchPrevAddressListAction({commit, getters, state}) {
  //   console.warn('fetchPrevAddressListAction : starting.....')
  //   let identifier;
  //   let account = getters.activeAccountGetter;
  //
  //
  //   if (!account) {
  //     console.warn(
  //       "fetchAddressesAction: No active account! Cannot fetch addresses"
  //     );
  //     return;
  //   }
  //
  //   if (state.activeUser === null) {
  //     identifier = account.pubkey;
  //   } else {
  //     identifier = account.apiId;
  //   }
  //
  //   let prev = getters.activeAccountGetter.metaAddress.prev;
  //   // console.log("Prev value for address API", prev)
  //
  //   let url = `${apiDomain}/v1/dashboard/account/${identifier}/addresses?${prev}`;
  //   const headers = {
  //     headers: {
  //       "Content-Type": "application/application-json",
  //       Authorization: `Bearer ${state.activeUser.userToken}`
  //     }
  //   };
  //   try {
  //     let result = await axios.get(url, headers)
  //     // console.log("Addresses Result",result.data)
  //     let addressesList = result.data.data || [];
  //     let meta = result.data.meta || {};
  //
  //     commit('UPDATE_ACCOUNT_ADDRESSES', {
  //       apiId: identifier,
  //       metaAddress: meta,
  //       addresses: addressesList
  //     })
  //     return result;
  //   } catch (err) {
  //     console.log('fetch prev address list error', err)
  //   }
  // },
  // async fetchNextAddressListAction({commit, getters, state}) {
  //
  //   console.warn('fetchNextAddressListAction : starting.....')
  //   let identifier;
  //   let account = getters.activeAccountGetter;
  //
  //
  //   if (!account) {
  //     console.warn(
  //       "fetchAddressesAction: No active account! Cannot fetch addresses"
  //     );
  //     return;
  //   }
  //
  //   if (state.activeUser === null) {
  //     identifier = account.pubkey;
  //   } else {
  //     identifier = account.apiId;
  //   }
  //
  //   let next = getters.activeAccountGetter.metaAddress.next;
  //
  //   // let string = getters.activeAccountGetter.metaAddress.next
  //   // console.log("String", string);
  //   // let index = string.indexOf('seek');
  //   // console.log("index", index);
  //   // let newString;
  //   // if(index >= 0)
  //   // {
  //   //   newString = string.substring(index);
  //   // }
  //   // console.log("New String", newString);
  //
  //   if (debugConsole) console.log("Next value for address API", next)
  //
  //   let url = `${apiDomain}/v1/dashboard/account/${identifier}/addresses?${next}`;
  //   const headers = {
  //     headers: {
  //       "Content-Type": "application/application-json",
  //       Authorization: `Bearer ${state.activeUser.userToken}`
  //     }
  //   };
  //   try {
  //     let result = await axios.get(url, headers)
  //     // console.log("Addresses Result",result.data)
  //     let addressesList = result.data.data || [];
  //     let meta = result.data.meta || {};
  //
  //     commit('UPDATE_ACCOUNT_ADDRESSES', {
  //       apiId: identifier,
  //       metaAddress: meta,
  //       addresses: addressesList
  //     })
  //     return result;
  //   } catch (err) {
  //     console.log('fetch Next Address List error', err)
  //   }
  //
  // },
  //
  // async fetchMoreAddressInfoAction({state, commit, getters}, address) {
  //   let identifier;
  //   let account = getters.activeAccountGetter;
  //   if (!account) {
  //     console.warn(
  //       "fetchTransactionsAction: No active account! Cannot fetch transactions"
  //     );
  //     return;
  //   }
  //   identifier = account.apiId; //apiID
  //   // console.log('Address', address);
  //   let url = `${apiDomain}/v1/dashboard/account/${identifier}/address/${address}`;
  //   const headers = {
  //     headers: {
  //       "Content-Type": "application/application-json",
  //       Authorization: `Bearer ${state.activeUser.userToken}`
  //     }
  //   };
  //
  //   try {
  //     let result = await axios.get(url, headers);
  //     //  console.log("View More Address Info result", result.data);
  //
  //     commit('UPDATE_SELECTED_ADDRESS_EXTRA_INFO', {
  //       address_metadata: result.data
  //     })
  //
  //   } catch (err) {
  //     console.log("View More Address info error", err)
  //   }
  // },

  //Transaction-based action
  // fetchTransactionsAction({ commit, getters, state }) {
  //   console.warn('fetchTransactionsAction: starting...');

  //   let identifier;
  //   let account = getters.activeAccountGetter;

  //   if (!account) {
  //     console.warn(
  //       'fetchTransactionsAction: No active account! Cannot fetch transactions'
  //     );
  //     return;
  //   }

  //   if (state.activeUser === null) {
  //     identifier = account.pubkey;
  //   } else {
  //     identifier = account.apiId;
  //   }
  //   let url = `${apiDomain}/v1/dashboard/account/${identifier}/txs`;
  //   const headers = {
  //     headers: {
  //       'Content-Type': 'application/application-json',
  //       Authorization: `Bearer ${state.activeUser.userToken}`,
  //     },
  //   };

  //   return axios
  //     .get(url, headers)
  //     .then(
  //       (result) => {
  //         //console.log(`fetchTransactionsAction: TripleA API : URL : ${url}`, JSON.stringify(result.data, null, 3));
  //         // console.log("result", result);
  //         let meta = result.data.meta || {};
  //         let transactions = result.data.data || [];
  //         // let prevLink = result.meta.prev;
  //         // let nextLink = result.meta.next;
  //         // let pageLimit = result.meta.params.limit;
  //         // console.log("Result meta", meta);
  //         commit('UPDATE_ACCOUNT_TRANSACTIONS', {
  //           apiId: identifier,
  //           metaTransaction: meta,
  //           transactions: transactions,
  //         });
  //         return result;
  //       },
  //       (error) => {
  //         console.error('fetchTransactionsAction: error', error);
  //         return error;
  //       }
  //     )
  //     .catch((error) => {
  //       console.error('fetchTransactionsAction: error', error);
  //       return error;
  //     });
  // },

  fetchPrevTransactionsAction({ commit, getters, state }) {
    console.warn('fetchPrevTransactionsAction : starting...');
    let identifier;
    let account = getters.activeAccountGetter;

    if (!account) {
      console.warn(
        'fetchTransactionsAction: No active account! Cannot fetch transactions'
      );
      return;
    }

    if (state.activeUser === null) {
      identifier = account.pubkey;
    } else {
      identifier = account.apiId;
    }

    let prev = getters.activeAccountGetter.metaTransaction.prev;
    console.log('Prev value', prev);

    let url = `${apiDomain}/v1/dashboard/account/${identifier}/txs?${prev}`;
    const headers = {
      headers: {
        'Content-Type': 'application/application-json',
        Authorization: `Bearer ${state.activeUser.userToken}`,
      },
    };

    return axios
      .get(url, headers)
      .then(
        (result) => {
          console.log('Next tx Result', result);
          let meta = result.data.meta || {};
          let transactions = result.data.data || [];
          // let prevLink = result.meta.prev;
          // let nextLink = result.meta.next;
          // let pageLimit = result.meta.params.limit;
          console.log('Result meta', meta);
          commit('UPDATE_ACCOUNT_TRANSACTIONS', {
            apiId: identifier,
            metaTransaction: meta,
            transactions: transactions,
          });
          return result;
        },
        (error) => {
          console.error('fetchNextTransactionsAction: error', error);
          return error;
        }
      )
      .catch((error) => {
        console.error('fetchNextTransactionsAction: error', error);
        return error;
      });
  },

  fetchNextTransactionsAction({ commit, getters, state }) {
    console.warn('fetchNextTransactionsAction: starting...');

    let identifier;
    let account = getters.activeAccountGetter;

    if (!account) {
      console.warn(
        'fetchTransactionsAction: No active account! Cannot fetch transactions'
      );
      return;
    }

    if (state.activeUser === null) {
      identifier = account.pubkey;
    } else {
      identifier = account.apiId;
    }

    let next = getters.activeAccountGetter.metaTransaction.next;
    console.log('Next value', next);
    let url = `${apiDomain}/v1/dashboard/account/${identifier}/txs?${next}`;
    const headers = {
      headers: {
        'Content-Type': 'application/application-json',
        Authorization: `Bearer ${state.activeUser.userToken}`,
      },
    };
    // return axios.get(url, headers, {
    //   params: {
    //     next
    //   }
    // })
    return axios
      .get(url, headers)
      .then(
        (result) => {
          console.log('Next tx Result', result);
          let meta = result.data.meta || {};
          let transactions = result.data.data || [];
          // let prevLink = result.meta.prev;
          // let nextLink = result.meta.next;
          // let pageLimit = result.meta.params.limit;
          console.log('Result meta', meta);
          commit('UPDATE_ACCOUNT_TRANSACTIONS', {
            apiId: identifier,
            metaTransaction: meta,
            transactions: transactions,
          });
          return result;
        },
        (error) => {
          console.error('fetchNextTransactionsAction: error', error);
          return error;
        }
      )
      .catch((error) => {
        console.error('fetchNextTransactionsAction: error', error);
        return error;
      });
  },

  // fetchTransactionCountsAction({ commit, getters, state }, { daysToDisplay }) {
  //   console.warn('fetchTransactionCountsAction: starting...');

  //   let account = getters.activeAccountGetter;

  //   if (!account) {
  //     console.warn(
  //       'fetchTransactionCountsAction: No active account! Cannot fetch transaction counts'
  //     );
  //     return;
  //   }

  //   let identifier = account.apiId;

  //   let toDate = new Date().setUTCHours(23, 59, 59, 999);
  //   let fromDate =
  //     new Date().setUTCHours(0, 0, 0, 0) - 24 * 60 * 60 * 1000 * daysToDisplay;
  //   toDate = new Date(toDate).toISOString().split('T')[0];
  //   fromDate = new Date(fromDate).toISOString().split('T')[0];

  //   let url = `${apiDomain}/v1/dashboard/account/${identifier}/txs/count?from_date=${fromDate}&to_date=${toDate}`;
  //   const headers = {
  //     headers: {
  //       Authorization: `Bearer ${state.activeUser.userToken}`,
  //     },
  //   };

  //   return axios
  //     .get(url, headers)
  //     .then(
  //       (result) => {
  //         let transactionCounts = result.data.tx_counts || [];

  //         commit('UPDATE_ACCOUNT_TRANSACTION_COUNTS', {
  //           apiId: identifier,
  //           transactionCounts: transactionCounts,
  //         });
  //         return result;
  //       },
  //       (error) => {
  //         console.error('fetchTransactionCountsAction: error', error);
  //         return error;
  //       }
  //     )
  //     .catch((error) => {
  //       console.error('fetchTransactionCountsAction: error', error);
  //       return error;
  //     });
  // },

  fetchPayoutsAction({ commit, getters }, { vm }) {
    let account = getters.activeAccountGetter;
    if (!account) return [];

    return vm.apiGetPayouts(account).then((responseData) => {
      commit('UPDATE_ACCOUNT_PAYOUTS', {
        apiId: account.apiId,
        payouts: responseData.data,
      });
      return responseData;
    });
  },

  async fetchFiatPayoutsAction(
    { commit, getters },
    { accessToken, perPage, page, ...searchForm }
  ) {
    let url = `${fiatApiDomain}/dashboard/transfers`;

    try {
      let result = await Axios.get(url, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${accessToken}`,
        },
        params: JSON.parse(
          JSON.stringify({
            per_page: perPage,
            page,
            ...searchForm,
          })
        ),
      });
      if (!result.data || result.status !== 200) {
        return;
      }

      commit('UPDATE_FIAT_PAYOUTS', {
        data: result.data,
        pagination: {
          page: result.headers['x-page'],
          perPage: result.headers['x-per-page'],
          total: result.headers['x-total'],
        },
      });
    } catch (error) {
      console.log('Error in retrieving more info', error);

      commit('UPDATE_FIAT_PAYOUTS', {
        data: [],
        pagination: {
          page,
          perPage,
          total: 0,
        },
      });

      throw error;
    }
  },

  async fetchFiatPayoutBalancesAction({ commit, getters }, { accessToken }) {
    let url = `${fiatApiDomain}/balances`;

    try {
      let result = await Axios.get(url, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${accessToken}`,
        },
      });
      if (!result.data || result.status !== 200) {
        return;
      }

      commit('UPDATE_FIAT_PAYOUT_BALANCES', result.data);
    } catch (error) {
      console.log('Error in retrieving more info', error);

      commit('UPDATE_FIAT_PAYOUT_BALANCES', []);

      throw error;
    }
  },

  async fetchMoreTransactionInfoAction({ commit, getters, state }, address) {
    let identifier;
    let account = getters.activeAccountGetter;
    if (!account) {
      console.warn(
        'fetchTransactionsAction: No active account! Cannot fetch transactions'
      );
      return;
    }
    identifier = account.apiId; //apiID
    let url = `${apiDomain}/v1/dashboard/account/${identifier}/address/${address}`;
    const headers = {
      headers: {
        'Content-Type': 'application/application-json',
        Authorization: `Bearer ${state.activeUser.userToken}`,
      },
    };

    try {
      let result = await axios.get(url, headers);
      console.log('More Transaction info result', result.data);

      commit('UPDATE_SELECTED_TRANSACTION_EXTRA_INFO', {
        address_metadata: result.data,
      });
    } catch (error) {
      console.log('Error in retreiving more info', error);
    }
  },

  async searchFunction({ commit, getters, state }, payload) {
    let identifier;
    let account = getters.activeAccountGetter;

    if (!account) {
      return;
    }

    if (state.activeUser === null) {
      identifier = account.pubkey;
    } else {
      identifier = account.apiId;
    }

    let url = `${apiDomain}/v1/dashboard/account/${identifier}/payments?q=${payload}`;

    const headers = {
      headers: {
        'Content-Type': 'application/application-json',
        Authorization: `Bearer ${state.activeUser.userToken}`,
      },
    };
    try {
      let result = await axios.get(url, headers);

      commit('UPDATE_SEARCH_RESULT', result.data.data);
      return result;
    } catch (err) {
      console.log('Addresses error', err);
    }
  },

  async saveCustomisationInfo({ commit, getters, state }, customInfo) {
    let merchantKey = getters.activeMerchantKeyGetter;

    if (!merchantKey) {
      console.warn(
        ' No Merchant Key Available ! Cannot save customisation info'
      );
    }

    let url = `${apiDomain}/v1/dashboard/merchant/${merchantKey}/hpp`;
    const headers = {
      'Content-Type': 'application/application-json',
      Authorization: `Bearer ${state.activeUser.userToken}`,
    };
    // if(!state.custom_info){
    //   console.warn("Custom_info is not available in state");
    // }

    const data = customInfo;

    try {
      let result = await axios.put(url, data, headers);
      if (debugConsole)
        console.log('Customisation info result', JSON.stringify(result));

      let newCustomInfo = result.data.hosted_page;
      if (debugConsole) console.log('New Custom info', newCustomInfo);

      if (newCustomInfo.btn_primary_background_color == '') {
        newCustomInfo.btn_primary_background_color = null;
      }

      if (newCustomInfo.btn_primary_color == '') {
        newCustomInfo.btn_primary_color = null;
      }

      if (newCustomInfo.page_background_color == '') {
        newCustomInfo.page_background_color = null;
      }

      if (debugConsole)
        console.log('New Custom Info after modification', newCustomInfo);
      commit('SAVE_NEW_CUSTOM_INFO', {
        newCustomInfo,
        merchantKey: getters.activeMerchantKeyGetter,
      });
    } catch (err) {
      console.log('Error in saving customisation data', err);
    }
  },

  async fetchMerchantWithdrawList({ commit, state }, payload) {
    const merchantKey = payload.merchant_key;
    if (!merchantKey) {
      console.warn(
        ' No Merchant Key Available ! Cannot proceed'
      );
    }
    let query_string = [];
    if (payload.payout_reference) {
      if (debugConsole)
        console.log('Payout Reference', payload.payout_reference);
      query_string.push(`q=${payload.payout_reference}`);
    }
    if (payload.from_date) {
      if (debugConsole) console.log('From Date', payload.from_date);
      query_string.push(`from_date=${payload.from_date}`);
    }
    if (payload.to_date) {
      if (debugConsole) console.log('To Date', payload.to_date);
      query_string.push(`to_date=${payload.to_date}`);
    }
    if (payload.status) {
      if (debugConsole) console.log('Status', payload.status);
      query_string.push(`status=${payload.status}`);
    }
    if (payload.from_modified_date) {
      if (debugConsole)
        console.log('Modified Date FROM', payload.from_modified_date);
      query_string.push(`from_modified_date=${payload.from_modified_date}`);
    }
    if (payload.to_modified_date) {
      if (debugConsole)
        console.log('Modified Date TO', payload.to_modified_date);
      query_string.push(`to_modified_date=${payload.to_modified_date}`);
    }
    if (payload.email) {
      if (debugConsole) console.log('email', payload.email);
      query_string.push(`email=${payload.email}`);
    }
    if (payload.bal_type) {
      if (debugConsole) console.log('Withdrawal type', payload.bal_type);
      query_string.push(`bal_type=${payload.bal_type}`);
    }
    if (payload.wallet_address) {
      query_string.push(`crypto_address=${payload.wallet_address}`);
    }
    if (payload.account_type) {
      // cater for crypto payouts admin page
      if (Array.isArray(payload.account_type)) {
        for (let type of payload.account_type) {
          query_string.push(`convert_type=${type}`);
        }
      }
      // cater for settlements page
      else {
        query_string.push(`convert_type=${payload.account_type}`);
      }
    }
    if (payload.sending_currency) {
      query_string.push(`sending_currency=${payload.sending_currency}`);
    }
    if (payload.receiving_currency) {
      query_string.push(`receiving_currency=${payload.receiving_currency}`);
    }
    if (payload.batch_id) {
      query_string.push(`batch_key=${payload.batch_id}`);
    }

    const url = `${apiDomain}/v1/dashboard/merchant/${merchantKey}/payouts?type=withdraw&${query_string.join(
      '&'
    )}`;
    const headers = {
      Authorization: `Bearer ${state.activeUser.userToken}`,
    };
    try {
      const result = await axios.get(url, headers);
      if (debugConsole) console.log('Payout list result', result);
      commit('UPDATE_PAYOUT_META_DATA', result.data.meta);
      const sortedByDate = result.data.data.sort(function (a, b) {
        return new Date(b.payout_date) - new Date(a.payout_date);
      });
      if (debugConsole) console.log('Payout List sorted BY Date', sortedByDate);
      commit('UPDATE_PAYOUT_LIST', sortedByDate);
    } catch (err) {
      console.error('Error in getting Merchant Payout List');
    }
  },

  async fetchMerchantBankAccounts({ state, commit }, payload) {
    let merchantKey = payload;
    if (!merchantKey) {
      console.warn('Merchant Key is not  found!');
    }

    let url = `${apiDomain}/v1/dashboard/merchant/${merchantKey}/bank_accounts`;
    const headers = {
      Authorization: `Bearer ${state.activeUser.userToken}`,
    };

    try {
      let result = await axios.get(url, headers);
      if (debugConsole) console.log('Merchant Bank Accounts', result.data);

      commit('UPDATE_MERCHANT_BANK_ACCOUNT', result.data);
    } catch (err) {
      console.error('Error in getting Merchant Bank Account', err);
    }
  },

  async fetchMerchantProfile({ state, commit }, payload) {
    let merchantKey = payload;
    if (!merchantKey) {
      console.warn('Merchant Key is not  found!');
    }

    let url = `${apiDomain}/v1/dashboard/merchant/${merchantKey}/profile`;
    const headers = {
      Authorization: `Bearer ${state.activeUser.userToken}`,
    };

    try {
      let result = await axios.get(url, headers);
      if (debugConsole) console.log('Merchant Profile', result.data);

      commit('UPDATE_MERCHANT_PROFILE_DETAILS', result.data);
    } catch (err) {
      console.error('Error in getting Merchant Profile', err);
    }
  },

  async saveMerchantProfileDetails({ state, commit }, payload) {
    const merchantKey = payload.merchant_key;
    if (!merchantKey) {
      console.warn('Merchant key is not found!');
    }

    const data = payload.data;

    const url = `${apiDomain}/v1/dashboard/merchant/${merchantKey}/profile`;
    const headers = {
      headers: {
        Authorization: `Bearer ${state.activeUser.userToken}`,
      },
    };
    try {
      const result = await Axios.put(url, data, headers);
      if (debugConsole) console.log('Merchant Profile Updated', result.data);

      commit('UPDATE_MERCHANT_PROFILE_DETAILS', result.data);
      return result;
    } catch (err) {
      console.error('Error in updating merchant profile', err);
      throw err;
    }
  },

  async addNewBankAccountDetails({ state, commit }, payload) {
    const merchantKey = payload.merchant_key;
    if (!merchantKey) {
      console.warn('Merchant key is not found!');
    }

    const data = payload.data;

    const url = `${apiDomain}/v1/dashboard/merchant/${merchantKey}/bank_account`;
    const headers = {
      headers: {
        Authorization: `Bearer ${state.activeUser.userToken}`,
      },
    };

    try {
      const result = await Axios.post(url, data, headers);
      if (debugConsole) {
        console.log('New Merchant Bank Account added', result.data);
      }

      commit('UPDATE_MERCHANT_BANK_ACCOUNT', result.data);
      return result;
    } catch (err) {
      console.error('Error in updating merchant bank account', err);
      throw err;
    }
  },

  async updateMerchantBankAccountDetails({ state }, payload) {
    const bankKey = payload.bank_key;
    if (!bankKey) {
      console.warn('Bank key is not found!');
    }

    const data = payload.data;

    const url = `${apiDomain}/v1/dashboard/merchant/bank_account/${bankKey}`;
    const headers = {
      headers: {
        Authorization: `Bearer ${state.activeUser.userToken}`,
      },
    };

    try {
      const result = await Axios.put(url, data, headers);
      return result;
    } catch (err) {
      console.error('Error in updating merchant bank account', err);
      throw err;
    }
  },

  async fetchExchangeRate({ commit }, payload) {
    let url = `${apiDomain}/v1/exchange_rates`;

    try {
      let result = await axios.get(url);
      if (debugConsole) console.log('get exchange rate result', result.data);

      //only shows the currency supported by TripleA
      let filteredResult = result.data.filter((item) =>
        payload.includes(item.fiat_currency)
      );
      if (debugConsole) console.log('FilteredResult', filteredResult);

      commit('UPDATE_EXCHANGE_RATE', filteredResult);
    } catch (err) {
      console.log('Error in getting exchange rate', err);
    }
  },

  async fetchMerchantPayouts({ commit, state }, payload) {
    if (debugConsole) console.log('Payload', payload);

    let merchantKey = payload.merchant_key;

    if (!merchantKey) {
      console.warn(
        ' No Merchant Key Available ! Cannot save customisation info'
      );
    }

    let query_string = [];

    if (payload.payout_reference) {
      if (debugConsole)
        console.log('Payout Reference', payload.payout_reference);
      query_string.push(`q=${payload.payout_reference}`);
    }

    if (payload.from_date) {
      if (debugConsole) console.log('From Date', payload.from_date);
      query_string.push(`from_date=${payload.from_date}`);
    }

    if (payload.to_date) {
      if (debugConsole) console.log('To Date', payload.to_date);
      query_string.push(`to_date=${payload.to_date}`);
    }

    if (payload.type) {
      if (debugConsole) console.log('Withdrawal type', payload.type);
      query_string.push(`type=${payload.type}`);
    }

    if (debugConsole) console.log('Query String', query_string);

    let url = `${apiDomain}/v1/dashboard/merchant/${merchantKey}/payouts?${query_string.join(
      '&'
    )}`;
    const headers = {
      Authorization: `Bearer ${state.activeUser.userToken}`,
    };
    try {
      let result = await axios.get(url, headers);
      let sortedByDate = result.data.data.sort(function (a, b) {
        return new Date(b.payout_date) - new Date(a.payout_date);
      });

      commit('UPDATE_MERCHANT_PAYOUTS', sortedByDate);
      return result;
    } catch (err) {
      console.error('Error in getting Merchant Payout List');
    }
  },

  async fetchMerchantExchangeRate({ commit }, payload) {
    let apiId = payload.api_id;
    let fromCurrency = payload.from_currency;
    let toCurrency = payload.to_currency;

    let url = `${apiDomain}/v1/exchange_rate/${apiId}/${fromCurrency}/${toCurrency}`;

    try {
      let result = await axios.get(url);
      if (this.debugConsole)
        console.log('get merchant exchange rate result', result.data);

      commit('UPDATE_MERCHANT_EXCHANGE_RATE', result.data);
      return result.data;
    } catch (err) {
      console.log('Error in getting exchange rate', err);
      return err;
    }
  },

  downloadTransactionAsCSV({ state, getters }, payload) {
    if (debugConsole)
      console.log('Download Transaction as CSV payload', payload);

    let identifier;
    let account = getters.activeAccountGetter;

    if (state.activeUser === null) {
      identifier = account.pubkey;
    } else {
      identifier = account.apiId;
    }

    let query_string = [];
    if (payload.payment_reference) {
      if (debugConsole) console.log('Search Text', payload.search_text);
      query_string.push(`payment_reference=${payload.payment_reference}`);
    }
    if (payload.last_modified_from_date) {
      query_string.push(`status_from_date=${payload.last_modified_from_date}`);
    }
    if (payload.last_modified_to_date) {
      query_string.push(`status_to_date=${payload.last_modified_to_date}`);
    }
    if (payload.status) {
      query_string.push(`status=${payload.status}`);
    }
    if (payload.email) {
      query_string.push(`payer_email=${payload.email}`);
    }
    if (payload.wallet) {
      query_string.push(`address=${payload.wallet}`);
    }
    if (payload.order_id) {
      query_string.push(`q=${payload.order_id}`);
    }
    if (payload.order_currency) {
      query_string.push(`order_currency=${payload.order_currency}`);
    }
    if (payload.crypto_currency) {
      query_string.push(`crypto_currency=${payload.crypto_currency}`);
    }

    //Date format is YYYY-MM-DD
    if (payload.from_date) {
      query_string.push(`from_date=${payload.from_date}`);
    }
    //Date format is YYYY-MM-DD
    if (payload.to_date) {
      query_string.push(`to_date=${payload.to_date}`);
    }

    if (debugConsole) console.log('Query String', query_string);

    let url;
    if (
      account.settlementType === 'localcurrency' &&
      !account.apiId.includes('_t')
    ) {
      let merchantKey = getters.activeMerchantKeyGetter;
      url = `${apiDomain}/v1/dashboard/merchant/${merchantKey}/payments/csv?${query_string.join(
        '&'
      )}`;
    } else {
      url = `${apiDomain}/v1/dashboard/account/${identifier}/payments/csv?${query_string.join(
        '&'
      )}`;
    }

    const headers = {
      Authorization: `Bearer ${state.activeUser.userToken}`,
    };

    const responseType = {
      responseType: 'blob',
    };

    return axios.get(url, headers, responseType).then(
      (result) => {
        return result;
      },
      (err) => {
        if (debugConsole) console.log('Error in download txn as csv', err);
        throw err;
      }
    );
  },

  // eslint-disable-next-line no-unused-vars
  checkExchangeRate({ state, getters }, payload) {
    let apiId = payload.api_id;
    let fromCurrency = payload.from_currency;
    let toCurrency = payload.to_currency;

    let url = `${apiDomain}/v1/exchange_rate/${apiId}/${fromCurrency}/${toCurrency}`;

    return axios.get(url).then(
      (res) => {
        if (debugConsole) console.log('Get exchange rate', res.data);
        return res;
      },
      (err) => {
        throw err;
      }
    );
  },

  // eslint-disable-next-line no-unused-vars
  getInvoiceUploadData({ state, getters }, payload) {
    if (payload) {
      console.debug('Get invoice upload data started');
    }

    let url = `${apiDomain}/v1/dashboard/invoice/upload`;
    const headers = {
      Authorization: `Bearer ${state.activeUser.userToken}`,
    };
    let data = {};
    data.mime_type = payload.mimeType;
    data.merchant_key = payload.merchantKey;

    return axios.post(url, data, headers).then(
      (res) => {
        if (debugConsole) console.log('Res', res);
        return res;
      },
      (err) => {
        throw err;
      }
    );
  },

  // eslint-disable-next-line no-unused-vars
  uploadInvoice({ state, getters }, payload) {
    if (!payload) {
      console.debug('No payload');
      return;
    }

    let uploadInvoiceData = payload.uploadInvoiceData;
    let contentType = payload.contentType;
    let file = payload.file;

    let url = uploadInvoiceData.url;
    let fields = uploadInvoiceData.fields;

    const headers = {
      Authorization: undefined,
    };

    let formData = new FormData();

    for (const [key, value] of Object.entries(fields)) {
      formData.append(key, value);
    }
    // formData.append("key", uploadInvoiceData.fields["key"])
    // formData.append("X-Amz-Algorithm", uploadInvoiceData.fields["X-Amz-Algorithm"]);
    // formData.append("X-Amz-Credential", uploadInvoiceData.fields["X-Amz-Credential"]);
    // formData.append("X-Amz-Date", uploadInvoiceData.fields["X-Amz-Date"]);
    // formData.append("X-Amz-Signature", uploadInvoiceData.fields["X-Amz-Signature"]);
    // formData.append("Policy", uploadInvoiceData.fields["Policy"]);
    formData.append('Content-Type', contentType);
    formData.append('file', file);

    if (debugConsole) console.log('Form Data', formData);

    // based on Axios from npm lib package, so headers need to be in object.
    return Axios.post(url, formData, headers).then(
      (res) => {
        if (debugConsole) console.log('Upload successful');
        return res;
      },
      (err) => {
        console.log('Error in upload', err.response);
        throw err;
      }
    );
  },

  // eslint-disable-next-line no-unused-vars
  getPaymentRequestToken({ state, getters }, apiId) {
    if (!apiId) { return; }
    const url = `${apiDomain}/v1/dashboard/account/${apiId}/token`;
    const accessToken = state.activeUser.userToken;
    const headers = {
      Authorization: `Bearer ${accessToken}`,
    };
    return axios.post(url, headers);
  },

  // eslint-disable-next-line no-unused-vars
  getMerchantPaymentRequestToken({ state }, merchantKey) {
    if (!merchantKey) {
      console.debug('No Merchant Key');
      return;
    }
    const url = `${apiDomain}/v1/dashboard/merchant/${merchantKey}/token`;
    const accessToken = state.activeUser.userToken;
    const headers = {
      Authorization: `Bearer ${accessToken}`,
    };

    return axios.post(url, headers).then(
      (res) => {
        if (debugConsole) console.log('Merchant Invoice token', res);
        return res;
      },
      (err) => {
        console.log('Merchant invoice token error', err);
        throw err;
      }
    );
  },

  // eslint-disable-next-line no-unused-vars
  createPaymentRequest({ state }, payload) {
    if (!payload) {
      console.debug('No payload');
      return;
    }

    const paymentRequestData = payload.data;
    const url = `${apiDomain}/v1/dashboard/invoice/create`;

    const headers = {
      Authorization: `Bearer ${state.activeUser.userToken}`,
      'Content-Type': 'application/json',
    };

    try {
      const result = Axios.post(url, paymentRequestData, { headers });
      return result;
    } catch (err) {
      console.error('Payment Request Error', err);
      throw err;
    }
  },
  sendEmailToPayer({ state }, payload) {
    console.debug('Start sending email...');

    if (!payload) {
      console.debug('No Payload for sending email to payer');
    }

    let paymentReference = payload.paymentReference;

    let url = `${apiDomain}/v1/dashboard/invoice/${paymentReference}/email`;

    const headers = {
      Authorization: `Bearer ${state.activeUser.userToken}`,
    };

    return axios.post(url, headers).then(
      (res) => {
        if (debugConsole) console.log('Send email to payer', res);
        return res;
      },
      (err) => {
        console.log('Send email to payer err', err);
        throw err;
      }
    );
  },

  //FOR MULTI CRYPTO
  async saveMerchantMethods({ state }, payload) {
    console.debug('Saving Merchant Methods');

    if (!payload) {
      console.debug('No payload for saving merchant Methods');
    }

    const merchantKey = payload.merchantKey;
    const data = payload.data;

    const url = `${apiDomain}/v1/dashboard/merchant/${merchantKey}/methods`;

    const headers = {
      headers: {
        Authorization: `Bearer ${state.activeUser.userToken}`,
      },
    };

    try {
      const result = await Axios.put(url, data, headers);
      return result;
    }
    catch (err) {
      console.log('Save methods error', err);
      throw err;
    }
  },

  //Payment-based API
  async fetchAddressesAction({ commit, getters, state }) {
    let identifier;
    let account = getters.activeAccountGetter;

    if (!account) {
      return;
    }

    if (state.activeUser === null) {
      identifier = account.pubkey;
    } else {
      identifier = account.apiId;
    }

    let url = `${apiDomain}/v1/dashboard/account/${identifier}/payments`;
    const headers = {
      headers: {
        'Content-Type': 'application/application-json',
        Authorization: `Bearer ${state.activeUser.userToken}`,
      },
    };
    try {
      let result = await axios.get(url, headers);

      if (debugConsole) console.debug('Address Result', result.data);

      let addressesList = result.data.data || [];
      let meta = result.data.meta || {};
      // console.log("Result meta without filter", result.data);

      commit('UPDATE_ACCOUNT_ADDRESSES', {
        apiId: identifier,
        metaAddress: meta,
        addresses: addressesList,
      });
      return result;
    } catch (err) {
      console.log('Addresses error', err);
    }
  },

  async fetchMoreAddressInfoAction(
    { state, commit, getters },
    paymentReference
  ) {
    // eslint-disable-next-line no-unused-vars
    let identifier;
    let account = getters.activeAccountGetter;
    if (!account) {
      console.warn(
        'fetchTransactionsAction: No active account! Cannot fetch transactions'
      );
      return;
    }
    identifier = account.apiId; //apiID
    let url = `${apiDomain}/v1/dashboard/payment/${paymentReference}`;
    const headers = {
      headers: {
        'Content-Type': 'application/application-json',
        Authorization: `Bearer ${state.activeUser.userToken}`,
      },
    };

    try {
      let result = await axios.get(url, headers);
      if (debugConsole)
        console.log('View More Address Info result', result.data);

      // commit('UPDATE_SELECTED_ADDRESS_EXTRA_INFO', {
      //   address_metadata: result.data
      // })

      commit('UPDATE_SELECTED_ADDRESS_EXTRA_INFO', result.data);
    } catch (err) {
      console.log('View More Address info error', err);
      throw err;
    }
  },

  async fetchPaymentInfos({ state, commit }, paymentReference) {
    let url = `${apiDomain}/v1/dashboard/payment/${paymentReference}`;
    const headers = {
      headers: {
        'Content-Type': 'application/application-json',
        Authorization: `Bearer ${state.activeUser.userToken}`,
      },
    };
    try {
      let result = await axios.get(url, headers);
      if (debugConsole)
        console.log('View More Address Info result', result.data);
      commit('UPDATE_ASSOCIATED_PAYMENT_DETAILS', result.data);
      return result.data;
    } catch (err) {
      console.log('View More Address info error', err);
      throw err;
    }
  },

  async fetchPayments({ getters, state }, payload) {
    let query_string = [];
    if (payload.payment_reference) {
      if (debugConsole) console.log('Search Text', payload.search_text);
      query_string.push(`payment_reference=${payload.payment_reference}`);
    }
    if (payload.last_modified_from_date) {
      query_string.push(`status_from_date=${payload.last_modified_from_date}`);
    }
    if (payload.last_modified_to_date) {
      query_string.push(`status_to_date=${payload.last_modified_to_date}`);
    }
    if (payload.status) {
      query_string.push(`status=${payload.status}`);
    }
    if (payload.email) {
      query_string.push(`payer_email=${payload.email}`);
    }
    if (payload.wallet) {
      query_string.push(`address=${payload.wallet}`);
    }
    if (payload.order_id) {
      query_string.push(`q=${payload.order_id}`);
    }
    if (payload.order_currency) {
      query_string.push(`order_currency=${payload.order_currency}`);
    }
    if (payload.crypto_currency) {
      query_string.push(`crypto_currency=${payload.crypto_currency}`);
    }

    //Date format is YYYY-MM-DD
    if (payload.from_date) {
      query_string.push(`from_date=${payload.from_date}`);
    }
    //Date format is YYYY-MM-DD
    if (payload.to_date) {
      query_string.push(`to_date=${payload.to_date}`);
    }

    if (debugConsole) console.log('Query String', query_string);
    let url;
    const headers = {
      headers: {
        'Content-Type': 'application/application-json',
        Authorization: `Bearer ${state.activeUser.userToken}`,
      },
    };
    if (payload.account_id) {
      url = `${apiDomain}/v1/dashboard/account/${payload.account_id
        }/payments?${query_string.join('&')}`;
      return axios
        .get(url, headers)
        .then((result) => {
          if (debugConsole)
            console.debug('Address Result with search & filter', result.data);
          return result;
        })
        .catch((err) => {
          if (debugConsole)
            console.error('Addresses Result with search & filter error', err);
          return err;
        });
    } else {
      let merchantKey = getters.activeMerchantKeyGetter;
      url = `${apiDomain}/v1/dashboard/merchant/${merchantKey}/payments?${query_string.join(
        '&'
      )}`;
      return await axios
        .get(url, headers)
        .then((result) => {
          if (debugConsole)
            console.debug(
              'Local currency txn Result with search & filter',
              result.data
            );
          // commit('UPDATE_LOCAL_CURRENCY_TXN',result.data);
          return result;
        })
        .catch((err) => {
          console.error(
            'Local currency txn result with search & filter error',
            err
          );
          return err;
        });
    }
  },

  async fetchPrevAddressListAction({ commit, state }, searchResults) {
    let url = `${apiDomain}/v1/dashboard/account/${searchResults.apiId}/payments?${searchResults.metaAddress.prev}`;
    const headers = {
      headers: {
        'Content-Type': 'application/application-json',
        Authorization: `Bearer ${state.activeUser.userToken}`,
      },
    };
    try {
      let result = await axios.get(url, headers);
      // console.log("Addresses Result",result.data)
      let addressesList = result.data.data || [];
      let meta = result.data.meta || {};

      commit('UPDATE_ACCOUNT_ADDRESSES', {
        apiId: searchResults.apiId,
        metaAddress: meta,
        addresses: addressesList,
      });
      return result;
    } catch (err) {
      console.log('fetch prev address list error', err);
    }
  },
  async fetchNextAddressListAction({ commit, state }, searchResults) {
    let url = `${apiDomain}/v1/dashboard/account/${searchResults.apiId}/payments?${searchResults.metaAddress.next}`;
    const headers = {
      headers: {
        'Content-Type': 'application/application-json',
        Authorization: `Bearer ${state.activeUser.userToken}`,
      },
    };
    try {
      let result = await axios.get(url, headers);
      // console.log("Addresses Result",result.data)
      let addressesList = result.data.data || [];
      let meta = result.data.meta || {};

      commit('UPDATE_ACCOUNT_ADDRESSES', {
        apiId: searchResults.apiId,
        metaAddress: meta,
        addresses: addressesList,
      });
      return result;
    } catch (err) {
      console.log('fetch Next Address List error', err);
    }
  },

  async fetchAddressesCountAction(
    { commit, getters, state },
    { daysToDisplay }
  ) {
    let account = getters.activeAccountGetter;

    if (!account) {
      console.warn(
        'fetchAddressesCountsAction: No active account! Cannot fetch address counts'
      );
      return;
    }

    let identifier = account.apiId;

    let toDate = new Date().setUTCHours(23, 59, 59, 999);
    // console.log("To Date", new Date(toDate).toISOString())
    let fromDate =
      new Date().setUTCHours(0, 0, 0, 0) - 24 * 60 * 60 * 1000 * daysToDisplay;
    // console.log("From Date", new Date(fromDate).toISOString())

    toDate = new Date(toDate).toISOString().split('T')[0];
    fromDate = new Date(fromDate).toISOString().split('T')[0];

    let url = `${apiDomain}/v1/dashboard/account/${identifier}/payments/summary?from_date=${fromDate}&to_date=${toDate}`;
    const headers = {
      headers: {
        Authorization: `Bearer ${state.activeUser.userToken}`,
      },
    };

    try {
      let result = await axios.get(url, headers);
      if (debugConsole) console.log('Result address count', result.data);
      if (debugConsole)
        console.debug('Address count result', result.data.address_counts);

      // eslint-disable-next-line no-unused-vars
      let countResult = result.data.address_counts;

      commit('UPDATE_ACCOUNT_ADDRESSES_COUNT', {
        apiId: identifier,
        // addressesCount: countResult
        addressesCount: result.data,
      });
      return result;
    } catch (err) {
      throw err;
    }
  },

  downloadPayoutAsCSV({ state, getters }, payload) {
    let query_string = [];
    if (payload.type) {
      query_string.push(`type=${payload.type}`);
    }
    if (payload.payout_reference) {
      query_string.push(`q=${payload.payout_reference}`);
    }
    if (payload.from_date) {
      query_string.push(`from_date=${payload.from_date}`);
    }
    if (payload.to_date) {
      query_string.push(`to_date=${payload.to_date}`);
    }
    if (payload.is_auto === true || payload.is_auto === false) {
      query_string.push(`is_auto=${payload.is_auto}`); // disabled value is not a boolean
    }
    if (payload.operator) {
      query_string.push(`operator=${payload.operator}`);
    }
    if (payload.payment_reference) {
      query_string.push(`payment_reference=${payload.payment_reference}`);
    }
    if (payload.status) {
      query_string.push(`status=${payload.status}`);
    }
    if (payload.from_modified_date) {
      query_string.push(`from_modified_date=${payload.from_modified_date}`);
    }
    if (payload.to_modified_date) {
      query_string.push(`to_modified_date=${payload.to_modified_date}`);
    }
    if (payload.email) {
      query_string.push(`email=${payload.email}`);
    }
    if (payload.order_id) {
      query_string.push(`order_id=${payload.order_id}`);
    }
    if (payload.wallet_address) {
      query_string.push(`crypto_address=${payload.wallet_address}`);
    }
    if (payload.bal_type) {
      query_string.push(`bal_type=${payload.bal_type}`);
    }
    if (payload.account_type) {
      for (let acc of payload.account_type) {
        query_string.push(`convert_type=${acc}`);
      }
    }
    if (payload.sending_currency) {
      query_string.push(`sending_currency=${payload.sending_currency}`);
    }
    if (payload.receiving_currency) {
      query_string.push(`receiving_currency=${payload.receiving_currency}`);
    }

    if (debugConsole) console.log('Query String', query_string);

    const merchantKey = getters.activeMerchantKeyGetter;
    const url = `${apiDomain}/v1/dashboard/merchant/${merchantKey}/payouts/csv?${query_string.join(
      '&'
    )}`;
    const headers = {
      Authorization: `Bearer ${state.activeUser.userToken}`,
    };
    const responseType = {
      responseType: 'blob',
    };

    return axios.get(url, headers, responseType).then(
      (result) => {
        return result;
      },
      (err) => {
        if (debugConsole) console.log('Error in download payouts as csv', err);
        throw err;
      }
    );
  },

  async downloadFiatPayoutsCSV(
    { state, getters },
    { accessToken, ...searchForm }
  ) {
    let url = `${fiatApiDomain}/dashboard/transfers/csv`;

    try {
      let result = await Axios.get(url, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
        params: JSON.parse(
          JSON.stringify({
            ...searchForm,
          })
        ),
      });
      if (!result.data || result.status !== 200) {
        throw new Error('Server error');
      }

      return result;
    } catch (error) {
      console.log('Error in retrieving more info', error);

      throw error;
    }
  },

  downloadNewPayoutAsCSV({ state }, payload) {
    if (debugConsole)
      console.log('Download New Payout as CSV payload', payload);

    let query_string = [];
    if (payload.type) {
      query_string.push(`type=${payload.type}`);
    }
    if (payload.payout_reference) {
      query_string.push(`q=${payload.payout_reference}`);
    }
    if (payload.from_date) {
      query_string.push(`from_date=${payload.from_date}`);
    }
    if (payload.to_date) {
      query_string.push(`to_date=${payload.to_date}`);
    }
    if (payload.is_auto === true || payload.is_auto === false) {
      query_string.push(`is_auto=${payload.is_auto}`); // disabled value is not a boolean
    }
    if (payload.operator) {
      query_string.push(`operator=${payload.operator}`);
    }
    if (payload.payment_reference) {
      query_string.push(`payment_reference=${payload.payment_reference}`);
    }
    if (payload.status) {
      query_string.push(`status=${payload.status}`);
    }
    if (payload.from_modified_date) {
      query_string.push(`from_modified_date=${payload.from_modified_date}`);
    }
    if (payload.to_modified_date) {
      query_string.push(`to_modified_date=${payload.to_modified_date}`);
    }
    if (payload.email) {
      query_string.push(`email=${payload.email}`);
    }
    if (payload.order_id) {
      query_string.push(`order_id=${payload.order_id}`);
    }
    if (payload.wallet_address) {
      query_string.push(`crypto_address=${payload.wallet_address}`);
    }
    if (payload.bal_type) {
      query_string.push(`bal_type=${payload.bal_type}`);
    }
    if (payload.account_type) {
      for (let acc of payload.account_type) {
        query_string.push(`convert_type=${acc}`);
      }
    }
    if (payload.sending_currency) {
      query_string.push(`sending_currency=${payload.sending_currency}`);
    }
    if (payload.receiving_currency) {
      query_string.push(`receiving_currency=${payload.receiving_currency}`);
    }

    if (debugConsole) console.log('Query String', query_string);

    const partnerId = payload.partnerId;
    const url = `${apiDomain}/v1/dashboard/partner/${partnerId}/payouts/csv?${query_string.join(
      '&'
    )}`;
    const headers = {
      Authorization: `Bearer ${state.activeUser.userToken}`,
    };
    const responseType = {
      responseType: 'blob',
    };
    return axios.get(url, headers, responseType).then(
      (result) => {
        console.log('Result partner CSV', result);
        return result;
      },
      (err) => {
        if (debugConsole) console.log('Error in download payouts as csv', err);
        throw err;
      }
    );
  },

  async fetchNextPayoutListAction({ commit, getters, state }, payload) {
    console.warn('fetchNextPayoutListAction : starting.....');

    let merchantKey = payload.merchant_key;
    let next = getters.payoutMetaDataGetter.next;

    let url = `${apiDomain}/v1/dashboard/merchant/${merchantKey}/payouts?type=withdraw&${next}`;
    const headers = {
      Authorization: `Bearer ${state.activeUser.userToken}`,
    };
    try {
      let result = await axios.get(url, headers);
      if (debugConsole) console.log('Payout list result', result);
      commit('UPDATE_PAYOUT_META_DATA', result.data.meta);

      let sortedByDate = result.data.data.sort(function (a, b) {
        return new Date(b.payout_date) - new Date(a.payout_date);
      });
      if (debugConsole) console.log('Payout List sorted BY Date', sortedByDate);
      commit('UPDATE_PAYOUT_LIST', sortedByDate);
      return result;
    } catch (err) {
      console.error('Error in getting Merchant Payout List');
      throw err;
    }
  },

  async fetchPrevPayoutListAction({ commit, getters, state }, payload) {
    console.warn('fetchNextPayoutListAction : starting.....');

    let merchantKey = payload.merchant_key;
    let prev = getters.payoutMetaDataGetter.prev;

    let url = `${apiDomain}/v1/dashboard/merchant/${merchantKey}/payouts?type=withdraw&${prev}`;
    const headers = {
      Authorization: `Bearer ${state.activeUser.userToken}`,
    };
    try {
      let result = await axios.get(url, headers);
      console.log('Payout list result', result);
      commit('UPDATE_PAYOUT_META_DATA', result.data.meta);

      let sortedByDate = result.data.data.sort(function (a, b) {
        return new Date(b.payout_date) - new Date(a.payout_date);
      });
      if (debugConsole) console.log('Payout List sorted BY Date', sortedByDate);
      commit('UPDATE_PAYOUT_LIST', sortedByDate);
      return result;
    } catch (err) {
      console.error('Error in getting Merchant Payout List');
      throw err;
    }
  },

  //FOR DASHBOARD SUBACCOUNTS AND PERMISSIONS

  async getCurrentActiveEntityAdminProfile({ commit, state }) {
    //need to change to prod API domain after testing is done

    let url = `${newApiDomain}/dashboard/v1/entity_admins/profile`;
    let headers = {
      Authorization: `Bearer ${state.activeUser.userToken}`,
    };

    try {
      let result = await axios.get(url, headers);
      if (debugConsole)
        console.log('Current entity admin Profile Result', result);
      commit('UPDATE_CURRENT_ACTIVE_ENTITY_ADMIN', result.data);
      return result;
    } catch (err) {
      console.log('Current entity admin Error', err);
      throw err;
    }
  },

  async getEntityAdminList({ commit, getters, state }) {
    let url = `${newApiDomain}/dashboard/v1/entity_admins`;
    let headers = {
      Authorization: `Bearer ${state.activeUser.userToken}`,
    };

    try {
      let result = await axios.get(url, headers);

      // check entity admins of current active merchant and populate the `merchants` object with the current active merchant id
      let entityAdminsForCurrentActiveMerchant = result.data.filter((item) => {
        if (item.merchants && item.merchants[getters.activeMerchantGetter.id]) {
          const filteredMerchants = Object.assign(
            {},
            {
              [getters.activeMerchantGetter.id]:
                item.merchants[getters.activeMerchantGetter.id],
            }
          );
          item.merchants = filteredMerchants;

          return item;
        }
      }).sort((a, b) => a.id - b.id);

      commit('UPDATE_ENTITY_ADMIN_LIST', entityAdminsForCurrentActiveMerchant);
      return entityAdminsForCurrentActiveMerchant;
    } catch (err) {
      console.log('Error', err);
      throw err;
    }
  },

  async getPermissionGroup({ commit, state }) {
    let url = `${newApiDomain}/dashboard/v1/groups`;
    let headers = {
      Authorization: `Bearer ${state.activeUser.userToken}`,
    };
    try {
      let result = await axios.get(url, headers);
      if (debugConsole) console.log('Get Permission Group', result.data);
      commit('UPDATE_PERMISSION_GROUP', result.data);
      return result;
    } catch (err) {
      console.log('Err', err);
      throw err;
    }
  },

  async createEntityAdmin({ state }, payload) {
    let url = `${apiDomain}/v1/dashboard/profile`;
    let headers = {
      Authorization: `Bearer ${state.activeUser.userToken}`,
    };
    try {
      let result = await axios.post(url, payload, headers);
      return result;
    } catch (err) {
      console.log('Err in creating new user', err);
      throw err;
    }
  },

  async linkEntityAdmin({ state }, payload) {
    let url = `${newApiDomain}/dashboard/v1/entity_admin_links`;
    let headers = {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${state.activeUser.userToken}`,
    };

    try {
      let result = await axios.post(url, payload, headers);
      return result;
    } catch (err) {
      console.log('Err', err);
      throw err;
    }
  },

  async updateUserPermission({ state }, payload) {
    let groupEntityAdminLinkId = payload.group_entity_admin_link_id;

    let reqBody = {};
    reqBody.group_id = payload.group_id;
    reqBody.entity_admin_link_id = payload.entity_admin_link_id;

    if (debugConsole) {
      console.log('Group Entity Admin Link Id', groupEntityAdminLinkId);
      console.log(
        'Type of group entity admin link id',
        typeof groupEntityAdminLinkId
      );

      console.log('Group Id', reqBody.group_id);
      console.log('Type of group id', typeof reqBody.group_id);

      console.log('Entity Admin Link Id', reqBody.entity_admin_link_id);
      console.log(
        'Type of entity admin link id',
        typeof reqBody.entity_admin_link_id
      );
    }

    let url = `${newApiDomain}/dashboard/v1/group_entity_admin_links/${groupEntityAdminLinkId}`;
    let headers = {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${state.activeUser.userToken}`,
    };

    try {
      let result = await axios.put(url, reqBody, headers);
      if (debugConsole) console.log('Update entity admin results', result.data);
      return result;
    } catch (err) {
      console.log('Error in update User permission', err);
      throw err;
    }
  },

  async deleteUser({ state }, payload) {
    let groupEntityAdminLinkId = payload.group_entity_admin_link_id;

    if (debugConsole) {
      console.log('Group Entity Admin Link Id', groupEntityAdminLinkId);
      console.log(
        'Type of group entity admin link id',
        typeof groupEntityAdminLinkId
      );
    }

    let url = `${newApiDomain}/dashboard/v1/group_entity_admin_links/${groupEntityAdminLinkId}`;

    let headers = {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${state.activeUser.userToken}`,
    };

    try {
      let result = await axios.delete(url, headers);
      if (debugConsole) console.log('Delete Entity Admin Result', result.data);
      return result;
    } catch (err) {
      console.log('Error in delete entity admin', err);
      throw err;
    }
  },

  async createGroupEntityAdminLink({ state }, payload) {
    let url = `${newApiDomain}/dashboard/v1/group_entity_admin_links`;

    let headers = {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${state.activeUser.userToken}`,
    };

    try {
      let result = await axios.post(url, payload, headers);
      if (debugConsole)
        console.log('Create a group entity admin link Result', result.data);
      return result;
    } catch (err) {
      console.log('Error in creating a group entity admin link', err);
      throw err;
    }
  },

  //obtaining the merchant transactions using new API
  async fetchMerchantTransactions({ state, commit }, payload) {
    let merchantKey = payload.merchantKey;

    try {
      let url = `${apiDomain}/v1/dashboard/merchant/${merchantKey}/payments`;
      const headers = {
        Authorization: `Bearer ${state.activeUser.userToken}`,
      };

      let result = await axios.get(url, headers);
      if (debugConsole) console.log('Payment List Result', result.data);

      commit('UPDATE_LOCAL_CURRENCY_TXN', result.data);

      return result;
    } catch (err) {
      console.error('Error in getting the merchant Payment list', err);
      throw err;
    }
  },

  //obtaining the merchant transactions using new API
  async fetchMerchantTransactionsSummary({ state, commit }, payload) {
    let merchantKey = payload.merchantKey;
    try {
      let url = `${apiDomain}/v1/dashboard/merchant/${merchantKey}/payments/summary`;
      const headers = {
        Authorization: `Bearer ${state.activeUser.userToken}`,
      };
      let result = await axios.get(url, headers);
      if (debugConsole) console.log('Payment List summary Result', result.data);
      commit('UPDATE_LOCAL_CURRENCY_TXN_COUNTS', result.data);
      return result;
    } catch (err) {
      console.error('Error in getting the merchant Payment list summary', err);
      throw err;
    }
  },

  async fetchNextMerchantTransactions({ commit, getters, state }, next) {
    let merchantKey = getters.activeMerchantKeyGetter;
    let url = `${apiDomain}/v1/dashboard/merchant/${merchantKey}/payments?${next}`;
    const headers = {
      headers: {
        'Content-Type': 'application/application-json',
        Authorization: `Bearer ${state.activeUser.userToken}`,
      },
    };
    try {
      let result = await axios.get(url, headers);
      if (debugConsole) console.log('Next transaction Result', result.data);
      commit('UPDATE_LOCAL_CURRENCY_TXN', result.data);
      return result;
    } catch (err) {
      // console.log('Error in getting next transactions', err);
      throw err;
    }
  },

  async fetchPrevMerchantTransactions({ commit, getters, state }, prev) {
    let merchantKey = getters.activeMerchantKeyGetter;
    let url = `${apiDomain}/v1/dashboard/merchant/${merchantKey}/payments?${prev}`;
    const headers = {
      headers: {
        'Content-Type': 'application/application-json',
        Authorization: `Bearer ${state.activeUser.userToken}`,
      },
    };
    try {
      let result = await axios.get(url, headers);
      if (debugConsole) console.log('Prev transaction Result', result.data);
      commit('UPDATE_LOCAL_CURRENCY_TXN', result.data);
      return result;
    } catch (err) {
      if (debugConsole) console.log('Error in getting prev transactions', err);
      throw err;
    }
  },

  //save 2fa settings
  save2faSettings({ state }, payload) {
    let merchantKey = payload.merchantKey;
    let data = payload.data;

    let url = `${apiDomain}/v1/dashboard/merchant/${merchantKey}/settings/2fa`;

    const headers = {
      Authorization: `Bearer ${state.activeUser.userToken}`,
    };

    return axios.put(url, data, headers).then(
      (res) => {
        if (debugConsole) console.log('Save 2fa settings result', res.data);
        return res;
      },
      (err) => {
        console.log('Save 2fa settings error', err);
        throw err;
      }
    );
  },

  async fetchTransactionFromSearchBar({ commit, getters, state }, payload) {
    console.warn('fetchTransactionFromSearchBar');
    let account = getters.activeAccountGetter;
    if (!account) {
      return;
    }

    let query_string = [];
    if (payload.search_text) {
      if (debugConsole) console.log('Search Text', payload.search_text);
      query_string.push(`q=${payload.search_text}`);
    }

    //Date format is YYYY-MM-DD
    // if (payload.from_date) {
    //   if (debugConsole) console.log("From Date", payload.from_date);
    //   query_string.push(`from_date=${payload.from_date}`);
    //
    // }

    //Date format is YYYY-MM-DD
    // if (payload.to_date) {
    //   if (debugConsole) console.log("To Date", payload.to_date);
    //   query_string.push(`to_date=${payload.to_date}`);
    // }

    if (debugConsole) console.log('Query String', query_string);

    let url;
    const headers = {
      headers: {
        'Content-Type': 'application/application-json',
        Authorization: `Bearer ${state.activeUser.userToken}`,
      },
    };

    let merchantKey = getters.activeMerchantKeyGetter;
    url = `${apiDomain}/v1/dashboard/merchant/${merchantKey}/payments?${query_string.join(
      '&'
    )}`;

    try {
      let result = await axios.get(url, headers);

      if (debugConsole)
        console.debug(
          'Local currency txn Result with search & filter',
          result.data
        );

      commit('UPDATE_SEARCH_RESULT', result.data);
      return result;
    } catch (err) {
      console.error(
        'Local currency txn result with search & filter error',
        err
      );
      return err;
    }

    // if(account.settlementType === 'localcurrency'
    //   && !account.apiId.includes('_t'))
    // {
    //
    //
    // }
    //
  },

  async fetchMerchantRefundList({ commit, state }, payload) {
    if (debugConsole) console.log('Payload in Refund List', payload);

    let merchantKey = payload.merchant_key;

    if (!merchantKey) {
      console.warn(
        ' No Merchant Key Available ! Cannot save customisation info'
      );
    }

    let query_string = [];
    if (payload.payout_reference) {
      if (debugConsole)
        console.log('Payout Reference', payload.payout_reference);
      query_string.push(`q=${payload.payout_reference}`);
    }
    if (payload.from_date) {
      if (debugConsole) console.log('From Date', payload.from_date);
      query_string.push(`from_date=${payload.from_date}`);
    }
    if (payload.to_date) {
      if (debugConsole) console.log('To Date', payload.to_date);
      query_string.push(`to_date=${payload.to_date}`);
    }
    if (payload.is_auto === true || payload.is_auto === false) {
      query_string.push(`is_auto=${payload.is_auto}`); // disabled value is not a boolean
    }
    if (payload.operator) {
      if (debugConsole) console.log('Operator', payload.operator);
      query_string.push(`operator=${payload.operator}`);
    }
    if (payload.payment_reference) {
      if (debugConsole)
        console.log('Payent reference', payload.payment_reference);
      query_string.push(`payment_reference=${payload.payment_reference}`);
    }
    if (payload.status) {
      if (debugConsole) console.log('Status', payload.status);
      query_string.push(`status=${payload.status}`);
    }
    if (payload.from_modified_date) {
      if (debugConsole)
        console.log('Modified Date FROM', payload.from_modified_date);
      query_string.push(`from_modified_date=${payload.from_modified_date}`);
    }
    if (payload.to_modified_date) {
      if (debugConsole)
        console.log('Modified Date TO', payload.to_modified_date);
      query_string.push(`to_modified_date=${payload.to_modified_date}`);
    }
    if (payload.email) {
      if (debugConsole) console.log('email', payload.email);
      query_string.push(`email=${payload.email}`);
    }
    if (payload.order_id) {
      query_string.push(`order_id=${payload.order_id}`);
    }

    if (debugConsole) console.log('Query String', query_string);

    let url = `${apiDomain}/v1/dashboard/merchant/${merchantKey}/payouts?type=refund&${query_string.join(
      '&'
    )}`;

    const headers = {
      Authorization: `Bearer ${state.activeUser.userToken}`,
    };

    try {
      let result = await Axios.get(url, { headers });
      if (this.debugConsole) console.log('Refund list result', result);
      commit('UPDATE_REFUND_META_DATA', result.data.meta);

      let sortedByDate = result.data.data.sort(function (a, b) {
        return new Date(b.payout_date) - new Date(a.payout_date);
      });
      commit('UPDATE_REFUND_LIST', sortedByDate);
      return sortedByDate;
    } catch (err) {
      console.error('Error in getting Merchant Refund List');
    }
  },

  async fetchNextRefundListAction({ commit, getters, state }, payload) {
    console.warn('fetchNextRefundListAction : starting.....');

    let merchantKey = payload.merchant_key;
    let next = getters.refundMetaDataGetter.next;

    let url = `${apiDomain}/v1/dashboard/merchant/${merchantKey}/payouts?type=refund&${next}`;
    const headers = {
      Authorization: `Bearer ${state.activeUser.userToken}`,
    };
    try {
      let result = await axios.get(url, headers);
      if (debugConsole) console.log('Refund Next list result', result);
      commit('UPDATE_REFUND_META_DATA', result.data.meta);

      let sortedByDate = result.data.data.sort(function (a, b) {
        return new Date(b.payout_date) - new Date(a.payout_date);
      });
      if (debugConsole)
        console.log('Refund Next List sorted BY Date', sortedByDate);
      commit('UPDATE_REFUND_LIST', sortedByDate);
      return result;
    } catch (err) {
      console.error('Error in getting Merchant Refund Next List');
      throw err;
    }
  },

  async fetchPrevRefundListAction({ commit, getters, state }, payload) {
    console.warn('fetchPrevRefundListAction : starting.....');

    let merchantKey = payload.merchant_key;
    let prev = getters.refundMetaDataGetter.prev;

    let url = `${apiDomain}/v1/dashboard/merchant/${merchantKey}/payouts?type=refund&${prev}`;
    const headers = {
      Authorization: `Bearer ${state.activeUser.userToken}`,
    };
    try {
      let result = await axios.get(url, headers);
      console.log('Refund Prev list result', result);
      commit('UPDATE_REFUND_META_DATA', result.data.meta);

      let sortedByDate = result.data.data.sort(function (a, b) {
        return new Date(b.payout_date) - new Date(a.payout_date);
      });
      if (debugConsole)
        console.log('Refund Prev List sorted BY Date', sortedByDate);
      commit('UPDATE_REFUND_LIST', sortedByDate);
      return result;
    } catch (err) {
      console.error('Error in getting Merchant Prev Refund List');
      throw err;
    }
  },

  async cancelRefundWithRef({ state }, payload) {
    const url = `${apiDomain}/v1/dashboard/merchant/${payload.merchant_key}/refund/${payload.ref}/cancel`;

    const headers = {
      Authorization: `Bearer ${state.activeUser.userToken}`,
      'recaptcha-token': payload.recaptchaToken
    };
    return axios.put(url, {}, { headers }).then(
      (res) => {
        if (debugConsole) console.log('Cancelling the payout with ', url);
        return res;
      },
      (err) => {
        console.log('Error Cancelling the refund', err);
        throw err;
      }
    );
  },

  async resendEmail({ state }, payload) {
    if (debugConsole) console.log('trying to resend email to', payload);
    const url = `${apiDomain}/v1/dashboard/merchant/${payload.merchant_key}/${payload.payout_reference}/email/resend`;

    const headers = {
      Authorization: `Bearer ${state.activeUser.userToken}`,
    };

    return axios
      .post(url, headers)
      .then((res) => {
        if (debugConsole) console.log('email resent', res.data);
        return res;
      })
      .catch((err) => {
        console.log('resend email error', err);
        throw err;
      });
  },

  async updateEmail({ state }, payload) {
    if (debugConsole) console.log('trying to change email', payload);
    const url = `${apiDomain}/v1/dashboard/merchant/${payload.merchant_key}/${payload.payout_reference}/email/change`;
    const headers = {
      Authorization: `Bearer ${state.activeUser.userToken}`,
    };
    const data = { email: payload.newEmail };

    return axios
      .post(url, data, headers)
      .then((res) => {
        if (debugConsole) console.log('new email set', res.data);
        return res;
      })
      .catch((err) => {
        console.log('change email error', err);
        throw err;
      });
  },

  async getLatestRequestStatus({ state }, payload) {
    const url = `${apiDomain}/v1/dashboard/report/transaction`;
    const headers = {
      Authorization: `Bearer ${state.activeUser.userToken}`,
    };
    const data = { api_id: payload.id };
    return axios
      .get(url, headers, data)
      .then((res) => {
        return res;
      })
      .catch((err) => {
        throw err;
      });
  },

  async requestStatements({ state }, payload) {
    const url = `${apiDomain}/v1/dashboard/report/transaction`;
    const headers = {
      Authorization: `Bearer ${state.activeUser.userToken}`,
    };
    const data = {
      from_date: payload.from_date,
      to_date: payload.to_date,
      merchant_id: payload.merchant_id,
    };
    return axios
      .post(url, data, headers)
      .then((res) => {
        return res;
      })
      .catch((err) => {
        throw err;
      });
  },

  generateGstInvoicePDF({ state }, monthsList) {
    const url = `${apiDomain}/v1/dashboard/merchant/${state.activeMerchant.merchant_key}/tax-invoices/export`;
    const headers = {
      Authorization: `Bearer ${state.activeUser.userToken}`,
      'Content-Type': 'application/json',
      Accept: 'application/pdf',
      responseType: 'blob',
    };
    const payload = {
      months: monthsList,
    };
    return axios.post(url, payload, headers);
  },

  sendGstInvoiceEmail({ state }, payload) {
    const url = `${apiDomain}/v1/dashboard/merchant/${state.activeMerchant.merchant_key}/tax-invoices/email`;
    const headers = {
      Authorization: `Bearer ${state.activeUser.userToken}`,
    };
    const params = {
      months: payload.months,
      email_addresses: payload.emailList,
    };
    return axios.post(url, params, headers);
  },

  async apiGetApprovers({ commit, state }, merchantId) {
    const userToken = state.activeUser.userToken;
    if (debugConsole)
      console.debug('User Token to get payout approvers', userToken);

    if (!userToken) {
      return;
    }

    const url = `${newApiDomain}/dashboard/v1/approvers?merchant_id=${merchantId}`;
    const headers = {
      Authorization: `Bearer ${userToken}`,
    };

    try {
      const result = await axios.get(url, headers);
      commit('UPDATE_APPROVERS', result.data || []);
      return result;
    } catch (err) {
      if (debugConsole) console.log('Error in getting payout approvers', err);
      return;
    }
  },

  async apiAddApprovers({ state }, payload) {
    const userToken = state.activeUser.userToken;
    if (debugConsole)
      console.debug('User Token to create payout approvers', userToken);

    if (!userToken) {
      return;
    }
    const url = `${newApiDomain}/dashboard/v1/approvers`;
    const headers = {
      headers: {
        Authorization: `Bearer ${userToken}`,
      },
    };

    await axios.post(url, payload, headers);
  },

  async apiDeleteApprovers({ state }, approverId) {
    const userToken = state.activeUser.userToken;
    if (debugConsole)
      console.debug('User Token to delete payout approvers', userToken);

    if (!userToken) {
      return;
    }

    const url = `${newApiDomain}/dashboard/v1/approvers/${approverId}`;
    const headers = {
      headers: {
        Authorization: `Bearer ${userToken}`,
      },
    };

    await axios.delete(url, headers);
  },

  async apiGetApproval({ commit, state }, merchantId) {
    const userToken = state.activeUser.userToken;
    if (debugConsole)
      console.debug('User Token to get payout approvers', userToken);

    if (!userToken) {
      return;
    }

    const url = `${newApiDomain}/dashboard/v1/approval?merchant_id=${merchantId}`;
    const headers = {
      Authorization: `Bearer ${userToken}`,
    };

    try {
      const result = await axios.get(url, headers);
      commit('UPDATE_APPROVAL_TOTAL', result.data.approval_total);
      return result;
    } catch (err) {
      if (debugConsole) console.log('Error in getting payout approval', err);
      commit('UPDATE_APPROVAL_TOTAL', 0);
      return;
    }
  },

  async apiCreateApproval({ state }, payload) {
    const userToken = state.activeUser.userToken;
    if (debugConsole)
      console.debug('User Token to create payout approval', userToken);

    if (!userToken) {
      return;
    }

    const url = `${newApiDomain}/dashboard/v1/approval`;
    const headers = {
      headers: {
        Authorization: `Bearer ${userToken}`,
      },
    };

    await axios.post(url, payload, headers);
  },

  async downloadWithdrawalPDF({ state }, payload) {
    const userToken = state.activeUser.userToken;
    if (debugConsole) {
      console.debug('User Token to create payout approval', userToken);
    }

    if (!userToken) {
      return;
    }

    const url = `${apiDomain}/v1/dashboard/merchant/${payload.merchantKey}/payout/${payload.payoutReference}/pdf`;
    const headers = {
      Authorization: `Bearer ${userToken}`,
      'Content-Type': 'application/json',
      Accept: 'application/pdf',
      responseType: 'blob',
    };

    return axios.post(url, {}, headers);
  },

  async getMerchantDeposits({ state, commit }, payload) {
    const userToken = state.activeUser.userToken;
    if (debugConsole) {
      console.debug('User Token to create payout approval', userToken);
    }

    if (!userToken) {
      return;
    }

    let query_string = [];
    if (payload.depositReference) {
      query_string.push(`dpst_ref_num=${payload.depositReference}`);
    }
    if (payload.creationDateFrom) {
      query_string.push(`created_at_from=${payload.creationDateFrom}`);
    }
    if (payload.creationToFrom) {
      query_string.push(`created_at_to=${payload.creationToFrom}`);
    }

    // currently, status=new means deposits are transferred (done). Probably will change in the future on how to mark as done.
    const url = `${apiDomain}/v1/dashboard/merchant/${payload.merchantKey
      }/deposits?status=new&${query_string.join('&')}`;

    const headers = {
      Authorization: `Bearer ${userToken}`,
    };

    try {
      const result = await axios.get(url, headers);
      if (debugConsole) {
        console.log('Deposit result', result);
      }
      commit('UPDATE_MERCHANT_DEPOSITS_METADATA', result.data.meta);
      commit('UPDATE_MERCHANT_DEPOSITS', result.data.data);
    } catch (err) {
      console.error('Error in getting Merchant Deposit List');
    }
  },

  async fetchNextDepositListAction({ commit, getters, state }, payload) {
    console.warn('fetchNextDepositListAction : starting.....');

    const merchantKey = payload.merchant_key;
    const next = getters.depositsMetaDataGetter.next;

    const url = `${apiDomain}/v1/dashboard/merchant/${merchantKey}/deposits?${next}`;
    const headers = {
      Authorization: `Bearer ${state.activeUser.userToken}`,
    };
    try {
      const result = await axios.get(url, headers);
      if (debugConsole) {
        console.log('Deposit list result', result);
      }
      commit('UPDATE_MERCHANT_DEPOSITS_METADATA', result.data.meta);
      commit('UPDATE_MERCHANT_DEPOSITS', result.data.data);
      return result;
    } catch (err) {
      console.error('Error in getting Merchant Deposit List');
      throw err;
    }
  },

  async fetchPrevDepositListAction({ commit, getters, state }, payload) {
    console.warn('fetchPrevDepositListAction : starting.....');

    const merchantKey = payload.merchant_key;
    const prev = getters.depositsMetaDataGetter.prev;

    const url = `${apiDomain}/v1/dashboard/merchant/${merchantKey}/deposits?${prev}`;
    const headers = {
      Authorization: `Bearer ${state.activeUser.userToken}`,
    };
    try {
      const result = await axios.get(url, headers);
      if (debugConsole) {
        console.log('Deposit list result', result);
      }

      commit('UPDATE_MERCHANT_DEPOSITS_METADATA', result.data.meta);
      commit('UPDATE_MERCHANT_DEPOSITS', result.data.data);
      return result;
    } catch (err) {
      console.error('Error in getting Merchant Deposit List');
      throw err;
    }
  },

  // FIAT PAYOUT CREATION
  fetchPayoutIndividuals({ commit }, { token, queries }) {
    let url = `${fiatApiDomain}/individuals`;
    const headers = {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      }
    };
    if (queries) {
      let queryString = `?page=${queries.page}`;
      if (queries.name) {
        queryString += `&name=${queries.name}`;
      }
      if (queries.per_page) {
        queryString += `&per_page=${queries.per_page}`;
      }
      url += queryString;
    }
    try {
      return Axios.get(url, headers);
    } catch (e) {
      console.log('Error in API call to fetch indivs');
      throw e;
    }
  },
  fetchPayoutCompanies({ commit }, { token, queries }) {
    let url = `${fiatApiDomain}/companies`;
    const headers = {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      }
    };

    if (queries) {
      let queryString = `?page=${queries.page}`;
      if (queries.name) {
        queryString += `&name=${queries.name}`;
      }
      if (queries.per_page) {
        queryString += `&per_page=${queries.per_page}`;
      }
      url += queryString;
    }
    try {
      return Axios.get(url, headers);
    } catch (e) {
      console.log('Error in API call to fetch indivs');
      throw e;
    }
  },
  fetchPayoutDestinationAccounts({ commit }, { token, queries }) {
    let url = `${fiatApiDomain}/destination-accounts`;
    const headers = {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      }
    };

    if (queries) {
      let queryString = `?page=${queries.page}`;
      if (queries.per_page) {
        queryString += `&per_page=${queries.per_page}`;
      }
      url += queryString;
    }

    try {
      return Axios.get(url, headers);
    } catch (e) {
      console.log('Error in API call to fetch indivs');
    }
  },
  fetchFiatIndividual({ commit }, { token, id }) {
    const url = `${fiatApiDomain}/individuals/${id}`;
    const headers = {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      }
    };
    return Axios.get(url, headers);
  },
  fetchFiatCompany({ commit }, { token, id }) {
    const url = `${fiatApiDomain}/companies/${id}`;
    const headers = {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      }
    };
    return Axios.get(url, headers);
  },
  createFiatPayoutQuote({ commit }, { token, mode, sending_currency, sending_amount, receiving_currency, receiving_amount, source_country, destination_country, destination_account_id, charge_type }) {
    const url = `${fiatApiDomain}/quotes`;
    const headers = {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`
      }
    };
    const payload = {
      mode: mode,
      sending_currency: sending_currency,
      sending_amount: parseFloat(sending_amount),
      receiving_currency: receiving_currency,
      receiving_amount: parseFloat(receiving_amount),
      me_to_me_transfer: false,
      destination_account_id: destination_account_id,
      source_country: source_country,
      destination_country: destination_country
    };
    if (charge_type) {
      payload.charge_type = charge_type;
    }

    return Axios.post(url, payload, headers);
  },
  createFiatPayoutFromQuote({ state }, { token, quoteId, customId, senderId, destinationAccountId, purpose, sourceOfFunds, relationship, remarks }) {
    const url = `${fiatApiDomain}/quotes/${quoteId}/transfers`;
    const headers = {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      }
    };
    const payload = {
      'external_id': customId,
      'sender_id': senderId,
      'destination_account_id': destinationAccountId,
      'purpose_of_remittance': purpose,
      'source_of_funds': sourceOfFunds,
      'relationship': relationship,
      'remarks': remarks
    };
    return Axios.post(url, payload, headers);
  },
  confirmFiatPayout({ state }, { token, payoutId }) {
    const url = `${fiatApiDomain}/transfers/${payoutId}/confirm`;
    const headers = {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      }
    };
    const payload = {
      'payment_method': 'prefunding'
    };
    return Axios.post(url, payload, headers);
  },

  getFiatCountryList({ state }, token) {
    const url = `${fiatApiDomain}/countries`;
    const headers = {
      Authorization: `Bearer ${token}`,
    };
    return Axios.get(url, { headers });
  },
  getFiatBankList({ state }, { token, country_code, name, network, currency }) {
    let url = `${fiatApiDomain}/banks?country_code=${country_code}&page=1&per_page=500`;
    const headers = {
      Authorization: `Bearer ${token}`
    };
    if (name) {
      url += `&name=${name}`;
    }
    if (network) {
      url += `&network=${encodeURIComponent(network)}`;
    }
    if (currency) {
      url += `&currency=${currency}`;
    }
    return Axios.get(url, { headers });
  },
  getFiatPayoutCurrencyList() {
    const url = `${fiatApiDomain}/currencies`;
    return axios.get(url);
  },
  getMerchantFiatConfig({ state }, token) {
    const url = `${fiatApiDomain}/merchant-config`;
    const headers = {
      Authorization: `Bearer ${token}`
    };
    return Axios.get(url, { headers });
  },
  getBankAccountDetails({ state }, { token, bankAccountId }) {
    const url = `${fiatApiDomain}/destination-accounts?owner_id=${bankAccountId}`;
    const headers = {
      Authorization: `Bearer ${token}`
    };

    return Axios.get(url, { headers });
  },
  createFiatIndividualAccount({ state }, { token, payload }) {
    const url = `${fiatApiDomain}/individuals`;
    const headers = {
      Authorization: `Bearer ${token}`
    };
    return Axios.post(url, payload, { headers });
  },
  createFiatCorporateAccount({ state }, { token, payload }) {
    const url = `${fiatApiDomain}/companies`;
    const headers = {
      Authorization: `Bearer ${token}`
    };
    return Axios.post(url, payload, { headers });
  },
  createFiatDestinationAccount({ state }, { token, account }) {
    const url = `${fiatApiDomain}/destination-accounts`;
    const headers = {
      Authorization: `Bearer ${token}`
    };

    return Axios.post(url, account, { headers });
  },
  uploadFiatKycDocument({ state }, { token, data }) {
    const url = `${fiatApiDomain}/documents`;
    const headers = {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'multipart/form-data'
    };
    const payload = new FormData();
    payload.append('owner_id', data.owner_id);
    payload.append('category', 'identity_verification');
    payload.append('document_type', data.document_type);
    payload.append('file', data.file);
    return Axios.post(url, payload, { headers });
  },

  uploadDocForFiatPayout({ state }, { token, data }) {
    // use the same route as uploadFiatKycDocument but transfer_id = payoutId
    const url = `${fiatApiDomain}/documents`;
    const headers = {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'multipart/form-data'
    };
    const payload = new FormData();
    payload.append('transfer_id', data.payoutId);
    payload.append('category', 'transfer_purpose');
    payload.append('document_type', data.type);
    payload.append('file', data.file);

    return Axios.post(url, payload, { headers });
  },

  uploadDocForFiatAccount({ state }, { token, data }) {
    const url = `${fiatApiDomain}/documents`;
    const headers = {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'multipart/form-data'
    };
    const category = data.isCompany ? 'business_verification' : 'identity_verification';
    const payload = new FormData();
    payload.append('owner_id', data.entityId);
    payload.append('category', category);
    payload.append('document_type', data.document_type);
    payload.append('file', data.file);
    return Axios.post(url, payload, { headers });
  },

  getLegalEntityNameMerchant({ state }, { mkey, recaptchaToken }) {
    const url = `${apiDomain}/v1/dashboard/merchant/${mkey}/legal-entity`;
    const headers = {
      Authorization: `Bearer ${state.activeUser.userToken}`,
      'recaptcha-token': recaptchaToken
    };
    return Axios.get(url, { headers });
  },

  getFiatAccountRequiredFields({ state }, { token, country, currency, network }) {

    let url = `${fiatApiDomain}/required-fields?country_code=${country}&type=bank_account`;

    if (currency) {
      url += `&currency=${currency}`;
    }

    if (network) {
      url += `&network=${encodeURIComponent(network)}`;
    }

    const headers = {
      Authorization: `Bearer ${token}`
    };
    return Axios.get(url, { headers });
  },

  updateFiatIndividualAccount({ state }, payload) {
    const url = `${fiatApiDomain}/individuals/${payload.accountId}`;
    const headers = {
      Authorization: `Bearer ${payload.token}`
    };

    return Axios.patch(url, payload.account, { headers });
  },

  updateFiatCorporateAccount({ state }, payload) {
    const url = `${fiatApiDomain}/companies/${payload.accountId}`;
    const headers = {
      Authorization: `Bearer ${payload.token}`
    };
    return Axios.patch(url, payload.account, { headers });
  },

  updateFiatDestinationAccount({ state }, payload) {
    const url = `${fiatApiDomain}/destination-accounts/${payload.bankAccountId}`;
    const headers = {
      Authorization: `Bearer ${payload.token}`
    };
    return Axios.patch(url, payload.bankAccount, { headers });
  },

  getPayoutExchangeRate({ state }, { token, origin_currency, api_id = '' }) {
    const url = `${apiDomain}/v2/payout/exchange_rates/${origin_currency}${api_id ? `?api_id=${api_id}` : ''}`;
    const headers = {
      Authorization: `Bearer ${token}`
    };
    return Axios.get(url, { headers });
  },

  createCryptoPayoutDirect({ state }, { token, recaptchaToken, merchant_key, address, merchant_name, email, withdraw_currency, withdraw_amount, crypto_currency, crypto_amount, country, remarks = '', otp }) {
    const url = `${apiDomain}/v1/dashboard/merchant/${merchant_key}/payouts/local/crypto/direct`;
    const headers = {
      Authorization: `Bearer ${token}`,
      'recaptcha-token': recaptchaToken,
    };
    const payload = {
      'merchant_key': merchant_key,
      'email': email,
      'address': address,
      'name': merchant_name,
      'withdraw_currency': withdraw_currency,
      'withdraw_amount': withdraw_amount,
      'crypto_currency': crypto_currency,
      'crypto_amount': crypto_amount,
      'country': country,
      'username': state.activeUser.username,
      // 'password': 'Alex3AAAAA',
    };
    if (remarks) { payload.remarks = remarks; }
    if (otp) { payload.otp = otp; }
    return Axios.post(url, payload, { headers });
  },

  refreshCryptoPayout({ state }, { token, recaptchaToken, merchant_key, payout_reference }) {
    // const url = `${apiDomain}/v2/payout/withdraw/${payout_reference}/local/crypto/refresh`;
    const url = `${apiDomain}/v1/dashboard/merchant/${merchant_key}/payouts/${payout_reference}/local/crypto/refresh`;
    const headers = {
      Authorization: `Bearer ${token}`,
      'recaptcha-token': recaptchaToken,
    };
    return Axios.put(url, {}, { headers });
  },

  confirmCryptoPayout({ state }, { token, recaptchaToken, merchant_key, payout_reference, otp }) {
    // const url = `${apiDomain}/v2/payout/withdraw/${payout_reference}/local/crypto/confirm`;
    const url = `${apiDomain}/v1/dashboard/merchant/${merchant_key}/payouts/${payout_reference}/local/crypto/confirm`;
    const headers = {
      Authorization: `Bearer ${token}`,
      'recaptcha-token': recaptchaToken,
    };
    return Axios.put(url, { otp: otp }, { headers });
  },

  cancelDirectCryptoPayout({ state }, { recaptchaToken, merchantKey, payoutReference }) {
    const url = `${apiDomain}/v1/dashboard/merchant/${merchantKey}/payouts/${payoutReference}/local/crypto/cancel`;
    const payload = {
      'merchant_key': merchantKey,
      'payout_reference': payoutReference,

    };
    const headers = {
      Authorization: `Bearer ${state.activeUser.userToken}`,
      'recaptcha-token': recaptchaToken,
    };
    return Axios.put(url, payload, { headers });
  },

  createBatchCryptoPayout({ state }, { merchantKey, batchName, email, payouts, recaptchaToken }) {
    const url = `${newApiDomain}/dashboard/v1/batches`;
    const headers = {
      Authorization: `Bearer ${state.activeUser.userToken}`,
      'recaptcha-token': recaptchaToken,
    };
    const payload = {
      'merchant_key': merchantKey,
      'name': batchName,
      'notification_email': email,
      'payouts': payouts,
    };
    return axios.post(url, payload, {headers});
  },

  downloadCryptoPayoutsFromBatch({ state }, { batchId, status, recaptchaToken }) {
    let url = `${newApiDomain}/dashboard/v1/batches/${batchId}/payouts/download`;
    const headers = {
      Authorization: `Bearer ${state.activeUser.userToken}`,
      'recaptcha-token': recaptchaToken,
    };
    if (status) {
      url += `?status=${status}`;
    }
    return Axios.get(url, { headers });
  },

  /**
   * Gets the list of all batches
   * @returns 
   */
  getAllBatchesCryptoPayout({ state }, { batch_name, batch_id, ending_before, from_date, to_date, limit = 50, starting_after, status, recaptchaToken }) {
    const merchantId = state.activeMerchant.id;
    let url = `${newApiDomain}/dashboard/v1/batches?merchant_id=${merchantId}`;
    const headers = {
      Authorization: `Bearer ${state.activeUser.userToken}`,
      'recaptcha-token': recaptchaToken,
    };
    if (batch_name) {
      url += `&batch_name=${batch_name}`;
    }
    if (batch_id) {
      url += `&batch_id=${batch_id}`;
    }
    if (ending_before) {
      url += `&ending_before=${ending_before}`;
    }
    if (from_date) {
      url += `&from_date=${from_date}`;
    }
    if (to_date) {
      url += `&to_date=${to_date}`;
    }
    if (limit) {
      url += `&limit=${limit}`;
    }
    if (starting_after) {
      url += `&starting_after=${starting_after}`;
    }
    if (status) {
      url += `&status=${status}`;
    }

    return axios.get(url, { headers });
  },

  /**
   * get the list of payouts in a batch
   * @param {*} param0 
   * @param {*} width 
   */
  getPayoutsInBatch({ state }, { batchId, status, recaptchaToken, starting_after }) {
    let url = `${newApiDomain}/dashboard/v1/batches/${batchId}/payouts?limit=50`;
    const headers = {
      Authorization: `Bearer ${state.activeUser.userToken}`,
      'recaptcha-token': recaptchaToken,
    };
    if (status) {
      url += `&status=${status}`;
    }
    if (starting_after) {
      url += `&starting_after=${starting_after}`;
    }
    return axios.get(url, { headers } );
  },

  /**
   * gets the details of a specific batch
   */
  getBatchDetails({ state }, { batchId, recaptchaToken }) {
    const url = `${newApiDomain}/dashboard/v1/batches/${batchId}`;
    const headers = {
      Authorization: `Bearer ${state.activeUser.userToken}`,
      'recaptcha-token': recaptchaToken,
    };
    return axios.get(url, {headers} );
  },


  // ////////////////////////////////////////////
  // SIDEBAR & UI UX
  // ////////////////////////////////////////////

  updateSidebarWidth({ commit }, width) {
    commit('UPDATE_SIDEBAR_WIDTH', width);
  },
  updateI18nLocale({ commit }, locale) {
    commit('UPDATE_I18N_LOCALE', locale);
  },
  toggleContentOverlay({ commit }) {
    commit('TOGGLE_CONTENT_OVERLAY');
  },
  updateTheme({ commit }, val) {
    commit('UPDATE_THEME', val);
  },
  updateUserRole({ commit }, val) {
    commit('UPDATE_USER_ROLE', val);
  },
  updateWindowWidth({ commit }, width) {
    commit('UPDATE_WINDOW_WIDTH', width);
  },

  // ////////////////////////////////////////////
  // COMPONENT
  // ////////////////////////////////////////////

  // VxAutoSuggest
  updateStarredPage({ commit }, payload) {
    commit('UPDATE_STARRED_PAGE', payload);
  },

  //  The Navbar
  arrangeStarredPagesLimited({ commit }, list) {
    commit('ARRANGE_STARRED_PAGES_LIMITED', list);
  },
  arrangeStarredPagesMore({ commit }, list) {
    commit('ARRANGE_STARRED_PAGES_MORE', list);
  },
};

export default actions;
